<template>
<div class="chapter">
<div class="inner_page">
<div class="book" title="Kevin Belton's New Orleans Celebrations">
<div class="frontmatter">
<div class="recto">
<h1 class="title"><a id="index"><span class="ksmall"> Kevin Belton's<br/></span> New Orleans <br/>Celebrations</a></h1><a id="index">
<h3 class="author">Kevin Belton <span class="with">with</span> Rhonda K. Findley</h3>
<h4>Photographs by Eugenia Uhl</h4>
<img alt="Gibbs Smith Logo" src="images/logo.jpg"/>
</a></div><a id="index">
<div class="verso">
<p class="versotitle">Kevin Belton's New Orleans Celebrations</p>
<p>Digital Edition 1.0</p>
<p class="copyright">Text © 2019 Kevin Belton</p>
<p>Photographs © 2019 Eugenia Uhl except as noted otherwise</p>
<p>All rights reserved. No part of this book may be reproduced by any means whatsoever
            without written permission from the publisher, except brief portions quoted for purpose
            of review.</p>
<p class="nobreak">Gibbs Smith</p>
<p class="nobreak">P.O. Box 667</p>
<p>Layton, Utah 84041</p>
<p class="nobreak">Orders: 1.800.835.4993</p>
<p>www.gibbs-smith.com</p>
<p>ISBN: 9781423651567</p>
</div>
</a></div><a id="index">
<div class="frontmatter">
<div class="dedication" title="Dedication">
<p>To the great city of New Orleans, which is unlike any other city in the world. And to
            the people who have lived there, and to those who have visited here over the past 300
            years—you have added so much spice to this city, which I love so dearly.</p>
</div>
</div>
</a></div><a id="index">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?6e1f71c9